import { render } from "./YesOrNoResultRow.vue?vue&type=template&id=2285a58a&scoped=true&ts=true"
import script from "./YesOrNoResultRow.vue?vue&type=script&lang=ts"
export * from "./YesOrNoResultRow.vue?vue&type=script&lang=ts"

import "./YesOrNoResultRow.vue?vue&type=style&index=0&id=2285a58a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2285a58a"]])

export default __exports__